<template>
  <ipo3-page>
    <template slot="title">首頁專題</template>
    <template slot="tools">
      <el-select v-model="language" @change="onChangeLanguage" style="margin-right: 14px;">
        <el-option v-for="item in languages" :key="item.name" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">{{$t('btns.add')}}</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>

            <el-table-column
              :key="item.name"
              v-else-if="item.scope==='time'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                  {{scope.row.create_at|formDate}}
               </template>
            </el-table-column>
            
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id)"
                  size="mini"
                  type="success"
                >編輯</el-button>
                <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="首页新闻" name="1">
          首页新闻
        </el-tab-pane>
        <el-tab-pane label="推荐" name="2">认证信息</el-tab-pane>
      </el-tabs>-->
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "home-special",
  data() {
    return {
      activeName: "1",
      language: 'tw',
      languages: [{id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      items: this.$table.home_special,
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      var self = this;
      this.$http.get("/admin/HomeSpecial", {language: this.language}).then(res => {
        console.log("res:", res);
        let { data } = res.data;
        self.tableData = res.data.data;
      });
    },
    onCreate() {
      this.$router.push({ path: "/dashboard/home-special-edit", query: {language:this.language}});
    },
    onHandle(index, id) {
      this.$router.push({ path: `/dashboard/home-special-edit/${id}` });
    },
    onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/HomeSpecial/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            self.getData();
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },
    onChangeLanguage(value) {
      this.getData();
    },
  }
};
</script>